export default __webpack_public_path__ + "assets/img/file-icon.deae4054923f49c42b540527194c6a86.png";